export const URLS = {
    //produccion
    //URL_BASE: "https://visionbot-visionweb-backend.t0y4lz.easypanel.host",
    //desarrollo
    // En pruebas/producción se define REACT_APP_API_URL al compilar
    // (p. ej. https://api-vuc.cristiancicua.com). En local, el backend de siempre.
    URL_BASE: process.env.REACT_APP_API_URL || "http://localhost:3550",

    // ── Públicos ──────────────────────────────────────────────────────────────
    INICIAR_SESION: "/publico/auth/login",
    CERRAR_SESION: "/publico/auth/logout",
    REGISTRO: "/publico/registros/user",
    RECUPERAR_PASSWORD: "/publico/registros/recuperar-password",
    NUEVA_PASSWORD: "/publico/registros/nueva-password",
    CAMBIAR_PASSWORD: "/publico/registros/cambiar-password",
    CATALOGO_CIUDADES: "/publico/catalogos/ciudades",
    CATALOGO_BARRIOS: (codCiudad: number) => `/publico/catalogos/ciudades/${codCiudad}/barrios`,
  CATALOGO_DEPARTAMENTOS: "/publico/catalogos/departamentos",
  CATALOGO_MUNICIPIOS: (codDepartamento: string) =>
    `/publico/catalogos/departamentos/${codDepartamento}/municipios`,

    // ── Entidades ─────────────────────────────────────────────────────────────
    ENTIDADES_TODOS: "/privado/entidades/todos",
    ENTIDAD: (id: number) => `/privado/entidades/${id}`,
    ENTIDAD_AGREGAR: "/privado/entidades/agregar",
    ENTIDAD_ACTUALIZAR: (id: number) => `/privado/entidades/update/${id}`,
    ENTIDAD_ELIMINAR: (id: number) => `/privado/entidades/delete/${id}`,

    // ── Ciudades ──────────────────────────────────────────────────────────────
    CIUDADES_TODOS: "/privado/ciudades",
    CIUDAD: (id: number) => `/privado/ciudades/${id}`,

    // ── Barrios ───────────────────────────────────────────────────────────────
    BARRIOS_TODOS: "/privado/barrios",
    BARRIO: (id: number) => `/privado/barrios/${id}`,

    // ── Workflows ─────────────────────────────────────────────────────────────
    WORKFLOWS: "/privado/workflows",
    WORKFLOW: (id: number) => `/privado/workflows/${id}`,
    WORKFLOW_ETAPAS: (wId: number) => `/privado/workflows/${wId}/etapas`,
    WORKFLOW_ETAPA: (wId: number, eId: number) => `/privado/workflows/${wId}/etapas/${eId}`,
    WORKFLOW_ORDEN_ETAPAS: (wId: number) => `/privado/workflows/${wId}/orden-etapas`,
    WORKFLOW_PASOS: (wId: number, eId: number) => `/privado/workflows/${wId}/etapas/${eId}/pasos`,
    WORKFLOW_PASO: (pasoId: number) => `/privado/workflows/pasos/${pasoId}`,
    WORKFLOW_ROLES_RESPONSABLES_ETAPA: "/privado/workflows/config/roles-responsables-etapa",

    // ── Trámites ──────────────────────────────────────────────────────────────
    TRAMITES: "/privado/tramites/todos",
    TRAMITE_DETALLE: (id: number) => `/privado/tramites/${id}/detalle`,
    TRAMITE_TIMELINE: (id: number) => `/privado/tramites/${id}/timeline`,
    INICIAR_TRAMITE: (workflowId: number) => `/privado/tramites/iniciar/${workflowId}`,
    TRAMITE_ANULAR: (id: number) => `/privado/tramites/${id}/anular`,
    TRAMITE_REABRIR: (id: number) => `/privado/tramites/${id}/reabrir`,

    // ── Pasos de trámite ──────────────────────────────────────────────────────
    PASO_INICIAR: (tId: number, pId: number) => `/privado/tramites/${tId}/pasos/${pId}/iniciar`,
    PASO_SUBSANAR: (tId: number, pId: number) => `/privado/tramites/${tId}/pasos/${pId}/subsanar`,
    PASO_REENVIAR: (tId: number, pId: number) => `/privado/tramites/${tId}/pasos/${pId}/reenviar`,
    PASO_APROBAR: (tId: number, pId: number) => `/privado/tramites/${tId}/pasos/${pId}/aprobar`,
    PASO_DEVOLVER: (tId: number, pId: number) => `/privado/tramites/${tId}/pasos/${pId}/devolver`,
    PASO_ASIGNAR: (tId: number, pId: number) => `/privado/tramites/${tId}/pasos/${pId}/asignar`,

    // ── Documentos ────────────────────────────────────────────────────────────
    DOCS_SUBIR: (tId: number, pId: number) => `/privado/tramites/${tId}/pasos/${pId}/documentos/subir`,
    DOCS_LISTAR: (tId: number, pId: number) => `/privado/tramites/${tId}/pasos/${pId}/documentos`,
    DOCS_DESCARGAR: (tId: number, pId: number, docId: number) =>
        `/privado/tramites/${tId}/pasos/${pId}/documentos/${docId}/descargar`,

    // ── Funcionarios ──────────────────────────────────────────────────────────
    FUNCIONARIOS_MIS_PASOS: "/privado/funcionarios/mis-pasos",

    // ── Usuarios ──────────────────────────────────────────────────────────────
    USUARIOS_TODOS: "/privado/usuarios/todos",
    USUARIOS_AGREGAR: "/privado/usuarios/agregar",
    USUARIO_ELIMINAR: (id: number) => `/privado/usuarios/delete/${id}`,
    USUARIO_ASIGNAR_ENTIDAD: (id: number) => `/privado/usuarios/asignar-entidad/${id}`,

    // ── Departamentos ─────────────────────────────────────────────────────────
    DEPARTAMENTOS_TODOS: "/privado/departamentos",
    DEPARTAMENTO: (id: number) => `/privado/departamentos/${id}`,

    // ── Dashboard ─────────────────────────────────────────────────────────────
    DASHBOARD_ADMIN_RESUMEN: "/privado/dashboard/admin-resumen",
}